import { render, staticRenderFns } from "./ServiceTypeAvatar.vue?vue&type=template&id=0ba5b472&scoped=true&"
import script from "./ServiceTypeAvatar.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypeAvatar.vue?vue&type=style&index=0&id=0ba5b472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba5b472",
  null
  
)

export default component.exports